import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ShieldExclamationIcon } from '@heroicons/react/24/outline';

/**
 * Route protection component that checks if a feature is enabled
 * before allowing access to a route
 */
const FeatureProtectedRoute = ({ children, requiredFeature, featureName }) => {
  const { isFeatureEnabled, profile } = useAuth();

  // Super admins bypass all feature restrictions
  if (profile?.role === 'super_admin') {
    return children;
  }

  // If feature is not enabled, show access denied page
  if (!isFeatureEnabled(requiredFeature)) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center">
          <div className="flex justify-center mb-6">
            <div className="rounded-full bg-yellow-100 dark:bg-yellow-900/20 p-4">
              <ShieldExclamationIcon className="h-12 w-12 text-yellow-600 dark:text-yellow-400" />
            </div>
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            Feature Not Available
          </h2>
          
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            {featureName || 'This feature'} is not enabled for your organization.
          </p>
          
          <p className="text-sm text-gray-500 dark:text-gray-500 mb-6">
            Contact your organization administrator to enable this feature in Organization Settings.
          </p>
          
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default FeatureProtectedRoute;
